// Test IDs for the dedicated Contact page (`/contact`).
// Separate from the homepage inline enquiry form (`HOME.enquiry*`) so
// the two flows can be verified independently.

export const CONTACT = {
  // Page shell
  page: 'contact-page',
  hero: 'contact-hero',

  // Form
  form: 'contact-form',
  name: 'contact-name',
  email: 'contact-email',
  phone: 'contact-phone',
  interest: 'contact-interest',
  subject: 'contact-subject',
  message: 'contact-message',
  submit: 'contact-submit',
  success: 'contact-success',
  error: 'contact-error',

  // FAQ
  faqSection: 'contact-faq-section',
  faqItem: (idx) => `contact-faq-item-${idx}`,
  faqQuestion: (idx) => `contact-faq-question-${idx}`,
  faqAnswer: (idx) => `contact-faq-answer-${idx}`,

  // Nav
  navLink: 'nav-contact',
};
